export const waitForPrintResources = async (
  document: Document,
): Promise<void> => {
  const images = Array.from(document.querySelectorAll('img'))
    .filter(image => !image.complete)
    .map(
      image =>
        new Promise<void>(resolve => {
          image.addEventListener('load', () => resolve(), { once: true });
          image.addEventListener('error', () => resolve(), { once: true });
        }),
    );
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      Promise.all([document.fonts.ready, ...images]),
      new Promise<never>((_, reject) => {
        timer = setTimeout(
          () =>
            reject(
              new Error(
                'Report pictures are still loading. Try printing again.',
              ),
            ),
          30_000,
        );
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
};
